export const EmptySlotDashIcon = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="empty-slot-dash-icon"
      data-testid="empty-slot-dash-icon"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="13.1445" y="16.5" width="8" height="2" fill="#3B3B3B" />
    </svg>
  );
};
